<template>
    <div class="extended-contact-info">
        <form @submit.prevent="handleSubmit">
            <div class="row">
                <div class="form-group col-md-6">
                    <label for="lastName" class="control-label">Apellido</label>
                    <input class="form-control"
                           name="lastName"
                           id="lastName"
                           v-mask="{ regex: '[a-z A-Z]*' }"
                           v-model="formData.lastName"
                           placeholder="Ej: Rodriguez"
                           required />
                </div>
                <div class="form-group col-md-6">
                    <label for="firstName" class="control-label">Nombre</label>
                    <input class="form-control"
                           name="firstName"
                           v-mask="{ regex: '[a-z A-Z]*' }"
                           id="firstName"
                           v-model="formData.firstName"
                           placeholder="Ej: Juan"
                           required />
                </div>
            </div>
            <!-- Componente que muestra formulario con (Codigo de Area, Telefono y Email) -->
            <contact-info ref="contactInfoRef"/>
        </form>

    </div>
</template>
<script>
    import ContactInfo from "@/apps/shared/components/ContactInfo.vue";
    export default {
        components: {
            ContactInfo
        },
        data() {
            return {
                formData: {
                    areaCode: '',
                    telephone: '',
                    email: '',
                    firstName: '',
                    lastName: ''
                },
            };
        },
        methods: {
            setFormData(data) {
                this.formData = { ...data };
                this.$refs.contactInfoRef.setFormData(this.formData)
            },
            getFormData() {
                const contactInfoData = this.$refs.contactInfoRef.getFormData();
                return {
                    firstName: this.formData.firstName,
                    lastName: this.formData.lastName,
                    ...contactInfoData 
                };
            }
        }
    };
</script>

